define('views/content/lead',['require','views/base/item_page_view','typeahead','bloodhound','views/components/lead_note/lead_notes','collections/lead_notes','models/lead_note','views/components/action_history/action_histories','collections/action_histories','text!templates/content/lead.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');

    var LeadNotesView = require('views/components/lead_note/lead_notes');
    var LeadNotesCollection = require('collections/lead_notes');
    var LeadNoteModel = require('models/lead_note');

    var ActionsView = require('views/components/action_history/action_histories');
    var ActionsCollection = require('collections/action_histories');


    var temp = require("text!templates/content/lead.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'lead-page page',
        basePath: 'leads',
        titleKey: 'lead',
   
        afterInitialize: function () {
            this.country_distributor = {id: this.model.get("country_distributor") || ""};
            this.distributor = { id: this.model.get("distributor") || ""};
            this.reseller = { id: this.model.get("reseller") || ""};
            this.customer = { id: this.model.get("customer") || ""};

            this.notesCollection = new LeadNotesCollection([], {
                parameters: {
                    'lead_id': this.model.id
                }
            });

            this.actionsCollection = new ActionsCollection([], {
                parameters: {
                    'lead_id': this.model.id
                }
            });
            if (App.user.get('country_distributor')){
                 // If in cd context, set cd id for new lead
                this.model.set("country_distributor", App.user.get("country_distributor"));
            }else if (App.user.get('distributor')){
                 // If in distributor context, set distributor id for new lead
                this.model.set("distributor", App.user.get("distributor"));
            }else if (App.user.get('reseller')) {
                // If in reseller context, set reseller id for new lead
                this.model.set('reseller', App.user.get('reseller'));
            }
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',

                customerField: '.customers-typeahead',
                resellerField: '.resellers-typeahead',
                distributorField: '.distributor-typeahead',
                cdField: '.cds-typeahead',
                cityField: '.cities-typeahead',

                countrySelect: '#country',
                stateSelect: '#state',
                phoneCountrySelect: '#phone_country',
                contactPhoneCountrySelect: '#contact_phone_country',

                noteField: '#note',
                addNoteButton: '#add-note-button'
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',

            'change @ui.countrySelect': 'countryChanged',

            'click @ui.addNoteButton': 'addNoteButtonClicked'
        },

        regions: function() {
            return {
                NotesContainer: ".note-list",
                ActionsContainer: ".action-list",
            };
        },
    

        afterRender: function () {
            var _this = this;
            if (this.model.get('id')) {
                this.NotesContainer.show(new LeadNotesView({
                    collection: this.notesCollection
                }));

                this.ActionsContainer.show(new ActionsView({
                    collection: this.actionsCollection
                }));
            }

            // Setup typeahed for country distributor field
            var cdsTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'country-distributors/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.cdField.val()));
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cdField.typeahead({
                minLength: 3
            }, {
                name: 'country_distributors',
                source: cdsTypeahedEngine,
                display: 'company_name'
            });

            // Get selected country distributor's id
            this.ui.cdField.bind('typeahead:select', function (ev, suggestion) {
                _this.model.set('country_distributor', suggestion.id);
                _this.country_distributor = suggestion;
            });
            // Get changed country distributor's id
            this.ui.cdField.bind('typeahead:change', function (ev, suggestion) {
                _this.ui.resellerField.val(null);
                _this.ui.customerField.val(null);
                _this.ui.distributorField.val(null);
                _this.model.set('reseller', null);
                _this.model.set('customer', null);
                _this.model.set('distributor',null); 
                _this.distributor = {id: ""}; 
                _this.reseller = {id: ""};
                _this.customer = {id: ""}; 
            });

            // Setup typeahed for distributor field
            var distributorsTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'distributors/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.distributorField.val()) + 
                            '&cd_id=' + _this.country_distributor.id);
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.distributorField.typeahead({
                minLength: 3
            }, {
                name: 'distributors',
                source: distributorsTypeahedEngine,
                display: 'company_name'
            });

            // Get selected distributor's id
            this.ui.distributorField.bind('typeahead:select', function (ev, suggestion) {
                _this.model.set('distributor', suggestion.id);
                _this.distributor = suggestion;
            });
            // Get changed distributor's id
            this.ui.distributorField.bind('typeahead:change', function (ev, suggestion) {                
                _this.ui.resellerField.val(null);
                _this.ui.customerField.val(null);
                _this.model.set('reseller', null);
                _this.model.set('customer', null);
                _this.reseller = { id: "" };
                _this.customer = { id: "" }; 
                
            });

            // Setup typeahed for reseller field
            var resellersTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'resellers/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.resellerField.val()) +
                                      '&cd_id=' + _this.country_distributor.id +
                                      '&distributor_id=' + _this.distributor.id);
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.resellerField.typeahead({
                minLength: 3
            }, {
                name: 'resellers',
                source: resellersTypeahedEngine,
                display: 'company_name'
            });

            // Get selected reseller's id
            this.ui.resellerField.bind('typeahead:select', function (ev, suggestion) {
                _this.model.set('reseller', suggestion.id);
                _this.reseller = suggestion;
            });

            // Get changed reseller's id
            this.ui.resellerField.bind('typeahead:change', function (ev, suggestion) {
                _this.ui.customerField.val(null);
                _this.model.set('customer', null);
                _this.customer = { id: "" }; 
            });

            // Setup typeahed for customers field
            var customersTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'customers/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.customerField.val()) +
                            '&cd_id=' + _this.country_distributor.id +
                            '&distyributor_id=' + _this.distributor.id +
                            '&reseller_id=' + _this.reseller.id);
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.customerField.typeahead({
                minLength: 3
            }, {
                name: 'resellers',
                source: customersTypeahedEngine,
                display: 'company_name'
            });

            // Get selected customer's id
            this.ui.customerField.bind('typeahead:select', function (ev, suggestion) {
                _this.model.set('customer', suggestion.id);
                _this.customer = suggestion;
            });

            // Get selected customer's id
            this.ui.customerField.bind('typeahead:change', function (ev, suggestion) {

            });


            // Setup typeahed for city field
            var citiesTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'cities/typeahead/',
                    replace: function(url, query) {
                        var modifiedUrl = url + ('?query=' + _this.ui.cityField.val());

                        if (_this.model.get('country')) {
                            modifiedUrl += ('&country=' + _this.model.get('country'));
                        }

                        return modifiedUrl;
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cityField.typeahead({
                minLength: 3
            }, {
                name: 'cities',
                source: citiesTypeahedEngine,
                display: 'name'
            });
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'name': "required",
                    'contact_name': "required",
                    'country': "required",
                    'city_name': "required",
                    'phone_country': "required",
                    'phone_value': "required"
                },
                messages: {
                    'name': App.polyglot.t('name_required'),
                    'contact_name': App.polyglot.t('contact_name_required'),
                    'country': App.polyglot.t('country_required'),
                    'city_name': App.polyglot.t('city_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required')
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        addNoteButtonClicked: function () {
            var _this = this;

            if (!this.ui.noteField.val()) {
                App.utils.showMessage('error', App.polyglot.t('no_note_entered'));
                return;
            }

            this.ui.addNoteButton.addClass('loading');

            var note = new LeadNoteModel({
                'lead': this.model.id,
                'note': this.ui.noteField.val()
            });

            note.save(null, {
                success: function (model, response, options) {
                    _this.ui.addNoteButton.removeClass('loading');
                    _this.render();
                },
                error: function (model, response, options) {
                    _this.ui.addNoteButton.removeClass('loading');

                    // Show error messages
                    if (response.responseJSON.errors) {
                        for (var i=0; i<response.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', response.responseJSON.errors[i].message);
                        }
                    }
                }
            });
        },

        countryChanged: function () {
            var country_id = this.ui.countrySelect.val();

            if (country_id) {
                // Select same country in phone number field
                this.ui.phoneCountrySelect.val(country_id);
                this.ui.phoneCountrySelect.trigger('change');

                // Select same country in contact phone number field
                this.ui.contactPhoneCountrySelect.val(country_id);
                this.ui.contactPhoneCountrySelect.trigger('change');

                // Reset state and re render for state options of country
                this.ui.stateSelect.val(null);
                this.ui.stateSelect.trigger('change');
                this.render();
            }
        },


    });
});


